import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { Observable, of } from 'rxjs'

import { ErpOrder } from '../models/orderline'
import { FacetGroup } from '../../facets/models/facet-group'
import { Facet } from '../../facets/models/facet'
import { FacetCount } from '../../facets/models/facet-count'
import { AppliedFacets } from '../../facets/models/applied-facets'

import { environment } from '../../../environments/environment'

import { RequestWrap } from '../../core/models/request-wrap';
import { parseFacets } from '../../facets/helpers/facet-parser'
import { ThemeConfig } from '../../core/helpers/theme-config';

const ordersUrl = `/erporders?limit=${ThemeConfig.itemsPerPage}`

@Injectable()
export class OrderService {
    constructor(
        private http: HttpClient
    ) {}

    public getOrders(customerId: string, facets: AppliedFacets, nextPage = 1, lastId?: string): Observable<RequestWrap<ErpOrder[]>> {
        let params = parseFacets(facets).set('customerId', customerId).set('pagenr', nextPage.toString())

        if(lastId)
            params = params.append('lastId', lastId)

        return this.http.get<RequestWrap<ErpOrder[]>>(
            environment.baseApiUrl + ordersUrl,
            { params }
        )
    }

    public getFacetGroups(): Observable<FacetGroup[]> {
        return of([])
    }

    public getFacets(): Observable<Facet[]> {
        return of([])
    }

    public getFacetCounts(facets: AppliedFacets): Observable<FacetCount[]> {
        return of([])
    }
}
